import React, { useState } from 'react';
import Title from '../layouts/Title';
import Skills from './Skills';
import Achievement from './Achievement';
import Experience from './Experience';
import { motion } from 'framer-motion';

const Resume = () => {
  const [skillData, setSkillData] = useState(false);
  const [experienceData, setExperienceData] = useState(true);
  const [achievementData, setAchievementData] = useState(false);

  // Helper for tab styling
  const getTabClass = active =>
    `w-full h-20 text-xl font-titleFont flex justify-center items-center cursor-pointer duration-300 border-[1px] rounded-lg shadow-shadowOne ${
      active
        ? 'border-designColor text-designColor bg-black/40 shadow-neon'
        : 'border-transparent text-gray-400 bg-opacity-20 hover:bg-opacity-40'
    }`;

  return (
    <section id="resume" className="w-full py-20 border-b-[1px] border-b-gray-800">
      <div className="flex justify-center items-center text-center">
        <Title title="EXPERIENCE" des="My Resume" />
      </div>
      <div>
        <ul className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          <li
            onClick={() => {
              setSkillData(true);
              setExperienceData(false);
              setAchievementData(false);
            }}
            className={getTabClass(skillData)}
          >
            Professional Skills
          </li>
          <li
            onClick={() => {
              setSkillData(false);
              setExperienceData(true);
              setAchievementData(false);
            }}
            className={getTabClass(experienceData)}
          >
            Experience
          </li>
          <li
            onClick={() => {
              setSkillData(false);
              setExperienceData(false);
              setAchievementData(true);
            }}
            className={getTabClass(achievementData)}
          >
            Achievements
          </li>
        </ul>
      </div>

      <motion.div
        key={skillData ? 'skills' : experienceData ? 'exp' : 'achieve'}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="mt-10"
      >
        {skillData && <Skills />}
        {achievementData && <Achievement />}
        {experienceData && <Experience />}
      </motion.div>
    </section>
  );
};

export default Resume;
